<div class="text-editor">
  <!-- UF-45813 onPasteTitleData & onKeyPress event removed -->
  <ngx-text-editor [placeholder]="'Enter text here...'" [config]="editorConfig" [(ngModel)]="fieldValue" [spellcheck]="true"
    (ngModelChange)="updateDataOnChange()" (paste)="onPaste($event)" (focus)="updateClipboard();" (click)="calculateOccupancy();updateClipboard();">
  </ngx-text-editor>
  <div class="col-12 p-0 mt-1" id="alerContainer">
    <p class="mb-0" [ngClass]="maxLimitExceeds ? 'text-danger' : 'text-muted'" ><span *ngIf="maxLimitExceeds" class="sr-only">Error</span> {{alertMsg}}</p>
    <p class="mb-0" [ngClass]="containsBackslash ? 'text-danger' : ''" >
      <span *ngIf="containsBackslash" class="sr-only">Error</span> 
      {{noBackslash}}
    </p>
    <p class="mb-0" *ngIf="!clipboardReadPermission" class="text-danger" role="alert"><span class="sr-only">Error</span> Clipboard access needs to be enabled while copying data from external source</p>
  </div>
  <div class="col-12 p-0">
    <div class="d-flex justify-content-end pt-3">
      <div class="col-auto p-0">
        <button type="button" class="btn btn-cancel text-underline btn-sm mr-2" *ngIf="showCancel" (click)="onCancle();" id="calBtn">Cancel</button>
      </div>
      <div class="col-auto p-0">
        <button type="button" id="{{fieldValue}}updateBtn" class="btn btn-primary btn-sm"
          [disabled]="containsBackslash" *ngIf="showUpdateBtn"
          (click)="updateDataOnClick();" [disabled]="maxLimitExceeds">
          {{updateBtnText}}
        </button>
      </div>
    </div>
  </div>

</div>